import React, { useEffect } from 'react';
import HomeContainer from '../../../containers/student/home/HomeContainer';
import { useComponentContext } from '../../../context/ComponentContext';

function Home() {
  const { currentComponent, switchComponent } = useComponentContext();

  useEffect(() => {
    if (!currentComponent) {
      switchComponent('home', <HomeContainer />);
    }
  }, [currentComponent, switchComponent]);

  return (
    <>
      {currentComponent || <HomeContainer />}
    </>
  );
}

export default Home;